export default __webpack_public_path__ + "static/media/Text_Icon.33b23e78.svg";